import React from 'react'
import styled from 'styled-components'
import Fuse from 'fuse.js'

import AutoSuggest from 'react-autosuggest'

const theme = {
  container: {
    position: 'relative',
    boxSizing: 'initial',
  },
  input: {
    width: 240,
    height: 30,
    padding: '10px 20px',
    fontFamily: 'Helvetica, sans-serif',
    fontWeight: 300,
    fontSize: 16,
    border: '1px solid #aaa',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    boxSizing: 'initial',
  },
  inputFocused: {
    outline: 'none',
  },
  inputOpen: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  suggestionsContainer: {
    display: 'none',
    boxSizing: 'initial',
  },
  suggestionsContainerOpen: {
    display: 'block',
    position: 'absolute',
    top: 51,
    width: 280,
    border: '1px solid #aaa',
    backgroundColor: '#fff',
    fontFamily: 'Helvetica, sans-serif',
    fontWeight: 300,
    fontSize: 16,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    zIndex: 2,
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
    boxSizing: 'initial',
  },
  suggestion: {
    cursor: 'pointer',
    padding: '10px 20px',
    boxSizing: 'initial',
  },
  suggestionHighlighted: {
    backgroundColor: '#ddd',
  },
}

// Imagine you have a list of languages that you'd like to autosuggest.
const tasks = ['clip', 'sucker', 'deleaf'].map(t => ({ name: t }))
const fuse = new Fuse(tasks, {
  shouldSort: true,
  threshold: 1,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: ['name'],
})

// Teach Autosuggest how to calculate suggestions for any given input value.
const getSuggestions = value => {
  const results = fuse.search(value.trim())
  console.log(value, results)
  return results
}

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => <div>{suggestion.name}</div>

class AutoSuggestWrapper extends React.Component {
  constructor() {
    super()

    this.state = {
      value: '',
      suggestions: [],
    }
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
    })
  }

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: getSuggestions(value),
    })
  }

  render() {
    const { value, suggestions } = this.state

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: 'Type a programming language',
      value,
      onChange: this.onChange,
    }

    // Finally, render it!
    return (
      <AutoSuggest
        theme={theme}
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        getSuggestionValue={s => s.name}
        inputProps={inputProps}
        alwaysRenderSuggestions={true}
        renderSuggestion={renderSuggestion}
      />
    )
  }
}

export default AutoSuggestWrapper



// WEBPACK FOOTER //
// ./src/elements/AutoSuggest.js